import { useContext } from 'react';
import { formatPlurality } from '@trinity/chat-components';
import { SearchLoadingDashboardContext, SearchResultsDashboardContext } from '@/containers/WorkspaceGlobalSearch/Context';
import styles from './style/Tab.module.css';
import Table from './Search.Table.Dashboards';

const max = 50;

export default function SearchTabDashboards() {
  const dashboards = useContext(SearchResultsDashboardContext);
  const loading = useContext(SearchLoadingDashboardContext);

  const isLoading = loading.untouched && loading.loading;

  const data = dashboards?.items ?? [];
  const countText = !isLoading
    ? `(${getCountLabel(dashboards?.total ?? 0, 'Dashboard')})`
    : null;
  const pagination = data.length > 25;

  return (
    <div className={styles.root}>
      <Table
        data={data}
        countText={countText}
        pagination={pagination}
        pageSize={25}
        isLoading={isLoading} />
    </div>
  );
}

function getCountLabel(total: number, label: string) {
  return total > max
    ? `+${max} ${String(formatPlurality(label, max))}`
    : `${total} ${String(formatPlurality(label, total))}`;
}

export { SearchTabDashboards };